export default __webpack_public_path__ + "static/media/todoes.4b33d184.jpg";